// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-viewer--legend--content {
    flex-grow: 1; 
    display: flex;
    flex-direction: column;
    overflow: hidden;
     /* overflow-x: scroll; */
  
}


.chart-viewer--legend {
    position: relative;
    /* height: 48px; */
    min-height: 48px;
    border-top: 1px solid #d8d8d8;
    display: flex; 
   
  }
  
  .chart-viewer--legend--mask {
    position: absolute;
    width: calc(100% - 48px);
    height: 100%;
    line-height: 48px;
    text-align: right;
    background-color: white;
    /* border: 1px solid green; */
  }
  
  .chart-viewer--legend--toggle {
    position: absolute;
    right: 0;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    background-color: white;
  }
  
  .chart-viewer--legend--toggle.open {
    background-color: transparent;
  }
  
  .chart-viewer--legend--toggle:before {
    font-family: "health-stats-icons" !important;
    content: "\\e902";
    font-size: 32px;
  }
  
  .chart-viewer--legend--toggle.open:before {
    content: "\\e901";
  }
  
  .chart-viewer--top-toolbar,
  .chart-viewer--bottom-toolbar {
    z-index: 10;
  }
  


.legend {
    /* border: 1px solid #E4E4E6; */
    /* border-top: none; */
    max-height: 144px;
    overflow-x: scroll;
    display:flex;
    padding: 8px;
    width:auto;
    /* height: 144px; */
} 

.legend--group {
    /* border: 1px solid red; */
    margin-right: 16px;
} 

.legend--group--title {
    font-weight: 600;
    padding: 4px 8px;
    white-space: nowrap;
}

.legend--group--list {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: min-content;
    grid-template-rows: auto auto;
}


.legend--group--list--item {
    /* border: 1px solid blue; */
    line-height: 1em;
    padding: 8px;
    white-space: nowrap;
    font-size: 0.875rem;
}

.legend--group--list--item--swatch {
    width: 20px;
    height: 20px;
    /* background-color: blueviolet; */
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/indicator/legend/legend.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;KACf,wBAAwB;;AAE7B;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4CAA4C;IAC5C,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;;;AAIF;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,6BAA6B;AACjC;;;AAGA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB","sourcesContent":[".chart-viewer--legend--content {\r\n    flex-grow: 1; \r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n     /* overflow-x: scroll; */\r\n  \r\n}\r\n\r\n\r\n.chart-viewer--legend {\r\n    position: relative;\r\n    /* height: 48px; */\r\n    min-height: 48px;\r\n    border-top: 1px solid #d8d8d8;\r\n    display: flex; \r\n   \r\n  }\r\n  \r\n  .chart-viewer--legend--mask {\r\n    position: absolute;\r\n    width: calc(100% - 48px);\r\n    height: 100%;\r\n    line-height: 48px;\r\n    text-align: right;\r\n    background-color: white;\r\n    /* border: 1px solid green; */\r\n  }\r\n  \r\n  .chart-viewer--legend--toggle {\r\n    position: absolute;\r\n    right: 0;\r\n    width: 48px;\r\n    height: 48px;\r\n    text-align: center;\r\n    line-height: 48px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .chart-viewer--legend--toggle.open {\r\n    background-color: transparent;\r\n  }\r\n  \r\n  .chart-viewer--legend--toggle:before {\r\n    font-family: \"health-stats-icons\" !important;\r\n    content: \"\\e902\";\r\n    font-size: 32px;\r\n  }\r\n  \r\n  .chart-viewer--legend--toggle.open:before {\r\n    content: \"\\e901\";\r\n  }\r\n  \r\n  .chart-viewer--top-toolbar,\r\n  .chart-viewer--bottom-toolbar {\r\n    z-index: 10;\r\n  }\r\n  \r\n\r\n\r\n.legend {\r\n    /* border: 1px solid #E4E4E6; */\r\n    /* border-top: none; */\r\n    max-height: 144px;\r\n    overflow-x: scroll;\r\n    display:flex;\r\n    padding: 8px;\r\n    width:auto;\r\n    /* height: 144px; */\r\n} \r\n\r\n.legend--group {\r\n    /* border: 1px solid red; */\r\n    margin-right: 16px;\r\n} \r\n\r\n.legend--group--title {\r\n    font-weight: 600;\r\n    padding: 4px 8px;\r\n    white-space: nowrap;\r\n}\r\n\r\n.legend--group--list {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    grid-template-columns: min-content;\r\n    grid-template-rows: auto auto;\r\n}\r\n\r\n\r\n.legend--group--list--item {\r\n    /* border: 1px solid blue; */\r\n    line-height: 1em;\r\n    padding: 8px;\r\n    white-space: nowrap;\r\n    font-size: 0.875rem;\r\n}\r\n\r\n.legend--group--list--item--swatch {\r\n    width: 20px;\r\n    height: 20px;\r\n    /* background-color: blueviolet; */\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    margin-right: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
